export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client) {
    const authStore = useAuthStore();
    const { user, type: userType } = storeToRefs(authStore);

    if (!user.value) {
      return navigateTo({
        name: "auth-user_type-login",
        params: {
          user_type: String(userType.value),
        },
      });
    }
  }
});
